import { UiIconModel } from "../../models";

import { Group, UserSettings } from "./avatar";
import { DollarSignCircle, InfoCircle, New } from "./basic";
import {
    Calendar,
    CalendarDate,
    Checklists,
    Checkmark,
    DiagramNetwork,
    DiagramVenn,
    Email,
    Filter,
    Map,
    News,
    PageMultiple,
    Process,
    SmileyFace
} from "./content";
import {
    Badge,
    Bolt,
    Book,
    Bookmark,
    Box,
    Briefcase,
    Building,
    Clock,
    Flag,
    Headset,
    Leaf,
    Lego,
    Lightbulb,
    MagicWand,
    MagnifyingGlass,
    Megaphone,
    PartyPopper,
    Pencil,
    PencilWriting,
    SecurityCheckmark,
    Star,
    TrafficCone,
    Trophy
} from "./object";
import {
    BrowserCode,
    ButlerAutomation,
    Cloud,
    GitMerge,
    GlobeNetwork,
    GlobeNetworkLocation,
    TrelloCard,
    TrelloCardTemplates,
    TrelloLabels,
    TrelloWorkspaces
} from "./software";
import {
    AddOn,
    Automation,
    BoardDuplicate,
    ButlerAutomationHead,
    RocketInclined,
    Socket,
    Tray,
    TrelloCalendar,
    ViewCalendar,
    ViewTimeline
} from "./trello";

type UiIconProps = {
    model: UiIconModel;
};

// Icon map to reduce cyclomatic complexity
const iconMap: Record<string, () => JSX.Element | null> = {
    AddOn,
    Automation,
    Badge,
    BoardDuplicate,
    Bolt,
    Book,
    Bookmark,
    Box,
    Briefcase,
    BrowserCode,
    Building,
    ButlerAutomation,
    ButlerAutomationHead,
    Calendar,
    CalendarDate,
    Checklists,
    Checkmark,
    Clock,
    Cloud,
    DiagramNetwork,
    DiagramVenn,
    DollarSignCircle,
    Email,
    Filter,
    Flag,
    GitMerge,
    GlobeNetwork,
    GlobeNetworkLocation,
    Group,
    Headset,
    InfoCircle,
    Leaf,
    Lego,
    Lightbulb,
    MagicWand,
    MagnifyingGlass,
    Map,
    Megaphone,
    New,
    News,
    PageMultiple,
    PartyPopper,
    Pencil,
    PencilWriting,
    Process,
    RocketInclined,
    SecurityCheckmark,
    SmileyFace,
    Socket,
    Star,
    TrafficCone,
    Tray,
    TrelloCalendar,
    TrelloCard,
    TrelloCardTemplates,
    TrelloLabels,
    TrelloWorkspaces,
    Trophy,
    UserSettings,
    ViewCalendar,
    ViewTimeline
};

const UiIcon = ({ model }: UiIconProps) => {
    const IconComponent = iconMap[model.content.icon];
    return IconComponent ? IconComponent() : null;
};

export default UiIcon;
